import { CommonModule } from '@angular/common';
import { Component, Input } from '@angular/core';

export type ReviewerRoleCode = 'GA' | 'RT' | 'RF' | 'RJ' | 'RDPD' | 'JS';

export interface ReviewComment {
  userRole: string;
  comment: string | null;
  state: string | null;
}

@Component({
  selector: 'app-review-comments-block',
  standalone: true,
  imports: [CommonModule],
  templateUrl: './review-comments-block.component.html',
})
export class ReviewCommentsBlockComponent {
  @Input() comments: ReviewComment[] = [];

  roleLabel(role: string): string {
    switch (role) {
      case 'GA':
        return 'Grupo de apoyo';
      case 'RT':
        return 'Revisor técnico';
      case 'RF':
        return 'Revisor funcional';
      case 'RJ':
        return 'Revisor jurídico';
      case 'RDPD':
        return 'Revisor protección de datos';
      case 'JS':
        return 'Jefe de servicio';
      default:
        return role;
    }
  }

  stateLabel(state: string | null): string {
    return (state ?? '').toUpperCase() === 'APPROVED' ? 'Aprobado' : 'Subsanar';
  }
  stateClass(state: string | null): string {
    return (state ?? '').toUpperCase() === 'APPROVED' ? 'bg-green-100 text-green-800' : 'bg-amber-100 text-amber-800';
  }

  stateText(state?: string | null): string {
    switch ((state ?? '').toLowerCase()) {
      case 'approved':
        return 'Aprobado';
      case 'correction':
        return 'Sugiere Subsanación';
      case 'pending':
        return 'En espera de revisión';
      default:
        return 'Estado desconocido';
    }
  }
  commentText(comment?: string | null, state?: string | null): string {
    if (comment?.trim()) {
      return comment;
    }

    return (state ?? '').toLowerCase() === 'pending'
      ? 'Revisión pendiente.'
      : 'El revisor finalizó la revisión sin añadir comentarios.';
  }
  stateColor(state?: string | null): string {
    switch ((state ?? '').toLowerCase()) {
      case 'approved':
        return 'bg-success-base';
      case 'correction':
        return 'bg-warning-base';
      default:
        return 'bg-neutral-dark';
    }
  }
}
